export function randIntUpto(num: number) {
  return Math.floor(Math.random() * num)
}

export default {
  randIntUpto,
}
